import { Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell/base-cell.component';

@Component({
  selector: 'table-cell-html-highlight',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  template: `<div #ref [appHighlight]="config.text" [type]="'html'" [ngStyle]="config.styles"></div>`,
})
export class HtmlHighlightCellComponent extends BaseCellComponent {}
